module.exports = __webpack_public_path__ + "img/format_clear.156bc455.svg";